// eslint-disable
// this is an auto generated file. This will be overwritten

export const onChangeDiscussion = `subscription OnChangeDiscussion($cid: ID!) {
  onChangeDiscussion(cid: $cid) {
    id
    cid
    oid
    recordedAt
    topic
    comment
    recorder {
      id
      name
      type
    }
    status
    progress
    duration
    group {
      name
      seats {
        position
        memberId
      }
    }
    analysis
    annotations {
      id
      begin
      end
      label
      createdBy
      createdAt
      updatedBy
      updatedAt
    }
    timestamp
    options {
      isPrivate
      autoCorrection {
        enabled
        limit
      }
      useNewCaDa
      runAsr
      omitFullChannelAudio
    }
  }
}
`
export const onDeleteDiscussion = `subscription OnDeleteDiscussion($cid: ID!) {
  onDeleteDiscussion(cid: $cid) {
    id
    cid
    oid
    recordedAt
    topic
    comment
    recorder {
      id
      name
      type
    }
    status
    progress
    duration
    group {
      name
      seats {
        position
        memberId
      }
    }
    timestamp
    options {
      isPrivate
      autoCorrection {
        enabled
        limit
      }
      useNewCaDa
      runAsr
      omitFullChannelAudio
    }
  }
}
`
